import { IconButton } from "@/design-system/IconButton/IconButton";
import { useTranslation } from "@repo/shared/i18n";
import { ChevronLeft } from "lucide-react";
import { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  /**
   * Render as a non-interactive element (e.g. a decorative chevron nested inside
   * another button, where a nested <button> would be invalid). Defaults to a
   * real button.
   */
  as?: "button" | "span";
};

const BackButton = ({ as = "button", ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <IconButton
      as={as}
      {...(as === "button" ? { "aria-label": t("back") } : {})}
      icon={<ChevronLeft className="size-5 text-neutral-100" />}
      {...props}
    />
  );
};

export default BackButton;
